<div class="progresso">
  <div class="progresso__content" [ngClass]="definirTamanho('content')">
    <p class="content__legenda lovers-font--leahlee" [ngClass]="definirClasse()">
      {{ legenda }}
    </p>
    <!-- <p class="content__restante">
      {{ exibirValorAtual ? valorAtual : ""
      }}{{ exibirValorAtual && exibirValorTotal && exibirSeparador ? "/" : ""
      }}{{ exibirValorTotal ? valorTotal : "" }}{{ unidadeMedida }}
    </p> -->
    <div class="progresso__fundo" *ngIf="exibirFundoPreto"></div>
  </div>
  <circle-progress class="cs_circle-progress" [percent]="porcentagem" [radius]="definirTamanho('radius')"
    [outerStrokeWidth]="definirTamanho('outerStrokeWidth')" [animation]="true" [responsive]="false" [showTitle]="false"
    [showSubtitle]="false" [showUnits]="false" [innerStrokeWidth]="definirTamanho('innerStrokeWidth')"
    innerStrokeColor="transparent" outerStrokeColor="#721603" [backgroundPadding]="0" [renderOnClick]="false"
    [outerStrokeGradient]="true" [outerStrokeColor]="cor" [backgroundGradientStopColor]="corGradiante"
    [outerStrokeGradientStopColor]="definirStopColor()">
  </circle-progress>
  <div class="progresso__atual" [ngClass]="definirClasse()">
    <p class="atual__valor">
      {{valorAtual}}
    </p>
  </div>
</div>